import Vue from 'vue'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import VueAxios from 'vue-axios'

import parameters from '../../common/parameters'

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = parameters.api.baseUrl
    Vue.axios.defaults.headers.common['Security-Token'] = parameters.placeContextSecurityToken
    axiosRetry(Vue.axios, {
      retries: 3,
      retryDelay () {
          return 1000
      }
    })
  },

  query (uri, params) {
    return Vue.axios.get(`${uri}`, params)
  },

  get (uri = '') {
    return Vue.axios.get(`${uri}`)
  },

  post (uri, params) {
    return Vue.axios.post(`${uri}`, params)
  },

  update (uri, params) {
    return Vue.axios.put(`${uri}`, params)
  },

  put (uri, params) {
    return Vue.axios.put(`${uri}`, params)
  },

  delete (uri) {
    return Vue.axios.delete(`${uri}`)
  }
};

export default ApiService
